/* Custom What's In The Box — chemistry accordion.
   Only one item stays open at a time. */

(function () {
  function initSection(root) {
    if (root.dataset.witbReady) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-witb-item]'));
    if (!items.length) return;

    items.forEach(function (item, index) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other, i) {
          if (i !== index) other.open = false;
        });
      });
    });

    root.dataset.witbReady = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-witb]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
